import type { Product } from '@@partner:types:app'

import React from 'react'
import {
  calculateSalePercent,
  formatSaleFinishDate
} from '@@partner:helpers/product'

import './ProductPriceSale.scss'

export interface ProductPriceSaleProps {
  product: Product
}

function ProductPriceSale ({ product }: ProductPriceSaleProps) {
  const salePercent = calculateSalePercent(product.price, product.oldPrice)
  const saleFinishDate = product?.salePeriod?.finish ?? null

  if (salePercent > 0) {
    return (
      <div className={'ProductPriceSale__Label'}>
        −{salePercent}%
        {saleFinishDate && (
          <span className={'ProductPriceSale__Label__Till'}>
            {' '}
            до {formatSaleFinishDate(saleFinishDate)}
          </span>
        )}
      </div>
    )
  }

  return null
}

export default React.memo(ProductPriceSale)
